import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'ml.policychange.address.loading',
        defaultMessage: 'Loading...'
    },
    saving: {
        id: 'ml.policychange.address.saving',
        defaultMessage: 'Saving...'
    },
    makeChanges: {
        id: 'ml.policychange.address.makeChanges',
        defaultMessage: 'Make Changes'
    },
    nextBaseDescription: {
        id: 'ml.policychange.address.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.address.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    leavePolicy: {
        id: 'ml.policychange.address.leave this policy',
        defaultMessage: 'If you need to leave this policy in force until a future date, to get a quote for a new state, click on START A NEW QUOTE. Be sure to contact us when you are ready to cancel this policy.'
    },
    whenToStartANewQuote: {
        id: 'ml.policychange.address.When should I start a new quote instead',
        defaultMessage: 'When should I start a new quote instead?'
    },
    isMailingAddressSameAsAboveAddress: {
        id: 'ml.policychange.address.Is mailing address the same as the above address',
        defaultMessage: 'Is mailing address the same as the above address?'
    },
    isMailingAddressSameAsInsuredResidence: {
        id: 'ml.policychange.address.Is your mailing address the same as your insured residence',
        defaultMessage: 'Is your mailing address the same as your insured residence?'
    },
    isMailingAddressSameAsYourAddress: {
        id: 'ml.policychange.address.Is your mailing address the same as your address',
        defaultMessage: 'Is your mailing address the same as your address?'
    },
    youHaveChangedYourAddress: {
        id: 'ml.policychange.address.You have changed your address',
        defaultMessage: 'You have changed your address.'
    },
    verifyYourGaragingAddress: {
        id: 'ml.policychange.address.Please verify the garaging address for each of your vehicles',
        defaultMessage: 'Please verify the garaging address for each of your vehicles.'
    },
    addressHasBeenChaged: {
        id: 'ml.policychange.address.The address has been changed',
        defaultMessage: 'The address has been changed.'
    },
    verifyTheGaragingAddress: {
        id: 'ml.policychange.address.Please verify the garaging address for each of the vehicles',
        defaultMessage: 'Please verify the garaging address for each of the vehicles.'
    },
    updatedAddresses: {
        id: 'ml.policychange.address.Updated Addresses',
        defaultMessage: 'Updated Addresses'
    },
    addressDetail: {
        id: 'ml.policychange.address.Address details',
        defaultMessage: 'Address details'
    },
    changeMailingAddressOnEffectiveDate:{
        id: 'ml.policychange.address.changeMailingAddressOnEffectiveDate',
        defaultMessage: 'Change mailing address to the policy address on the effective date?'
    },
    ownerShipChangedError: {
        id: 'ml.policychange.address.ownerShipChangedError',
        defaultMessage: 'Ownership of the dwelling has changed. Cancel this policy and start a new quote.'
    },
    updateRequiredFields :{
        id: 'ml.policychange.address.updateRequiredFields',
        defaultMessage: 'Please update the missing deed information.'
    }
});
